import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL } from './urls'

// 列表
async function all() {
  return request({
    url: SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL,
    method: 'GET'
  })
}

async function getById(id) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${id}`,
    method: 'GET'
  })
}

// 插入
async function insert(data) {
  return request({
    url: SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL,
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 更新
async function update(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${data.id}`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

// 删除
async function remove(id) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${id}`,
    method: 'DELETE'
  })
}

// 启用
async function enable(id) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${id}/enable`,
    method: 'PUT'
  })
}

// 禁用
async function disable(id) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${id}/disable`,
    method: 'PUT'
  })
}

// 获取自定义字段
async function allCustomFields(id) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${id}/fields`,
    method: 'GET'
  })
}

// 添加自定义字段
async function addCustomField(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${data.configEntryFormId}/fields`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 更新自定义字段
async function updateCustomField(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${data.configEntryFormId}/fields/${data.id}`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

// 删除自定义字段
async function removeCustomField(configEntryFormId, customFieldId) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${configEntryFormId}/fields/${customFieldId}`,
    method: 'DELETE'
  })
}

// 批量删除自定义字段
async function batchRemoveCustomFields(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${data.configEntryFormId}/fields/batchRemove`,
    method: 'DELETE',
    params: qs.stringify({
      fieldIds: data.fieldIds
    })
  })
}

// 批量更新自定义字段
async function batchUpdateCustomFields(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL}/${data.configEntryFormId}/fields/batchSave`,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    data: JSON.stringify(data.fields)
  })
}

export default {
  all,
  getById,
  insert,
  update,
  remove,
  enable,
  disable,
  allCustomFields,
  addCustomField,
  updateCustomField,
  removeCustomField,
  batchUpdateCustomFields,
  batchRemoveCustomFields
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-config-entry-form.js